import EmailValidator from 'email-validator';

export default class FormValidate {
  constructor($form) {
    this.refs = {
      requiredField: '.js-required-field',
      emailField: '.js-email-field',
    };

    this.dom = {
      $form,
      $requiredFields: $form.querySelectorAll(this.refs.requiredField),
      $emailFields: $form.querySelectorAll(this.refs.emailField),
    };

    this.state = {
      errorClass: 'has-error',
      errorCount: 0,
    };
  }

  validate() {
    const { dom, state } = this;
    state.errorCount = 0;

    dom.$requiredFields.forEach(this.inputCheck.bind(this));
    dom.$emailFields.forEach(this.emailCheck.bind(this));

    return state.errorCount > 0;
  }

  inputCheck($field) {
    const $input = $field.querySelector('input');
    if (!$input) return;

    this.setField($field, $input, !!$input.value);
  }

  emailCheck($field) {
    const $input = $field.querySelector('input');
    if (!$input) return;

    const isValid = EmailValidator.validate($input.value);

    if (!isValid) {
      $input.value = '';
    }

    this.setField($field, $input, isValid);
  }

  setField($field, $input, valid) {
    const { state } = this;
    const label = $input.getAttribute('aria-label');
    const errorPlaceholder = `Please enter a valid ${label ? label.toLowerCase() : ''}`;

    if (!valid) {
      $field.classList.add(state.errorClass);
      $input.setAttribute('placeholder', errorPlaceholder);
      state.errorCount += 1;
    } else {
      $field.classList.remove(state.errorClass);
      $input.setAttribute('placeholder', label);
    }
  }
}
